<template>
  <div class="drafting">
    <div class="color-list">
      <div class="color-item"
           draggable="true"
           @dragstart="handleDragstart(index)"
           @drop.prevent="handleDrop()"
           @dragover.prevent="handleDragover(index)"
           v-for="(picture,index) in pictureList"
           :key="picture.url">
        <img :src="filePath + picture.url"
             class="el-upload-list__item-thumbnail"/>
        <i class="el-icon-delete" @click="deleteImg(picture.url)"></i>
      </div>
    </div>

    <div class="upload-but">
      <el-upload
        class="ib"
        :action="baseURL+'/api/mgr/upload/uploadFile'"
        :show-file-list="false"
        name="file"
        ref="upload"
        :limit="1"
        accept="image/*"
        :headers="headers"
        :on-exceed="handleExceed"
        :on-success="uploadCallback"
      >
        <el-button type="primary">图片上传</el-button>
      </el-upload>
    </div>

    <div v-if="!showTip" class="el-upload__tip upload-tips">
      上传商品图片，第一张图片将作为商品主图,支持同时上传多张图片,多张图片之间可随意调整位置；建议使用尺寸800x800像素以上、大小不超过1M的正方形图片
    </div>

  </div>
</template>

<script>

  export default {
    name: "drafting-upload-img",
    props: ['value', 'initPictureList','showTip'],
    data() {
      return {
        headers: {'token': localStorage.getItem("qc_token")},
        pictureList: [],
        oldItemIndex:-1,
        newItemIndex:-1,
      }
    },
    watch: {
      initPictureList(n) {
        this.pictureList = n;
      }
    },
    methods: {
      handleDragstart(index){
        this.oldItemIndex = index;
      },
      handleDrop(){
        const changeItem = this.pictureList.splice(this.oldItemIndex, 1)[0];
        this.pictureList.splice(this.newItemIndex, 0, changeItem);
      },
      handleDragover(index){
        this.newItemIndex = index;
      },
      uploadCallback(response, file) {
        if (response.code == 0) {
          var imageUrl = response.data.url;
          this.pictureList.push({url: imageUrl})
          this.$emit("getPictureList", this.pictureList);
        } else {
          this.msgAlert(response.desc);
        }
      },
      selectImage(url) {
        this.pictureList.push({url: url})
        this.$emit("getPictureList", this.pictureList);
      },
      handleExceed(files){
        this.$refs.upload.clearFiles();
        const file = files[0];
        this.$refs.upload.handleStart(file);
        this.$refs.upload.submit();
      },
      deleteImg(url) {
        this.$confirm('确认删除此图片?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {

          for (var i = 0, l = this.pictureList.length; i < l; i++) {
            var obj = this.pictureList[i];
            if (obj.url == url) {
              this.pictureList.splice(i, 1);
              break;
            }
          }

          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      deleteListValue(url) {
        var pictureList = this.pictureList;
        for (var i = 0, l = this.pictureList.length; i < l; i++) {
          var obj = pictureList[i];
          if (obj.url == url) {
            this.pictureList.splice(i, 1);
          }
        }
      },
    },
    mounted() {
      this.pictureList = this.initPictureList;
    }
  }
</script>

<style lang="less" scoped>
  .drafting {
    border: 1px solid #c0ccda;
    width: 100%;
  }

  .color-item {
    width: 148px;
    height: 148px;
    overflow: hidden;
    background-color: #fff;
    border: 1px solid #c0ccda;
    border-radius: 6px;
    margin: 10px;
    display: inline-block;
    position: relative;

  }

  .color-item img {
    width: 100%;
    height: 100%;
  }

  .color-item i {
    z-index: 99;
    position: absolute;
    top: 0;
    right: 0;
    font-size: 20px;
    color: red;
    padding: 2px;
    cursor: pointer;
    margin-left: 123px;
  }

  .upload-tips {
    color: @primary;
    margin: 10px;
  }

  .upload-but {
    margin: 10px;
  }
</style>
